import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import PlayButton from 'components/Core/WistiaVideo/components/PlayButton';
import InlinePlayer from '../components/InlinePlayer';
import { ThumbnailInlineContainer } from './styles';

const ThumbnailInline = ({ isPlaying }) => (
  <ThumbnailInlineContainer className="wistia-video--wrapper">
    {!isPlaying && <PlayButton alwaysShow />}
    <InlinePlayer />
  </ThumbnailInlineContainer>
);

export default WithWistiaContext(ThumbnailInline);
